import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "layout-3xBTd",
  "use": "layout-3xBTd-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol stroke-linecap=\"round\" stroke-linejoin=\"round\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"layout-3xBTd\"><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\" /><path d=\"M3 9h18M9 21V9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol